// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.timeline-slider-container {
    position: relative;
    margin-top: 0.125em;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-color);
}

div.timeline-slider {
    touch-action: none;
    flex: 1 1 auto;
    background-color: white;
    height: 35px;
    min-height: 0px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    user-select: none;
}

div.timeline-slider-cursor {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: black;
    z-index: 3;
}

div.timeline-slider-cursor-label {
    position: absolute;
    font-size: 70%;
    bottom: 0;
    text-align: center;
    background-color: var(--container-bg-color);
    color: var(--text-color);
    border: 1px solid var(--border-color);
    z-index: 4;
    transform: translateX(-50%);
    padding: 0 0.25em;
}

div.timeline-slider-cursor-label input {
    border: none!important;
    background-color: transparent!important;
    padding: 0.125em!important;
    height: initial!important;
}

div.timeline-slider-cursor-label input::-webkit-clear-button {
    display: none;
}

div.timeline-slider-layertitle {
    font-size: 75%;
    padding: 0.25em;
    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
    background-color: white;
    color: black;
    display: flex;
    align-items: center;
    position: absolute;
    z-index: 4;
    white-space: nowrap;
    overflow-x: auto;
}

div.timeline-slider-layertitle > span:first-child {
    font-weight: bold;
    margin-right: 1em;
}

div.timeline-slider-layertitle > select {
    margin-right: 1em;
}

div.timeline-slider-gradient {
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    min-height: 100%;
}

div.timeline-slider-feature {
    font-size: 75%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    height: 24px;
    padding: 0.25em;
    border-radius: 4px;
    background-color: var(--border-color);
    border: 1px solid transparent;
    z-index: 2;
}

div.timeline-slider-feature > span {
    flex: 1 1 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
}

div.timeline-slider-feature:hover {
    border: 1px solid var(--color-active);
}

div.timeline-slider-loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200, 0.9);
    color: black;
    z-index: 10;
}

div.timeline-slider-loading > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}`, "",{"version":3,"sources":["webpack://./components/timeline/style/TimelineFeaturesSlider.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,2CAA2C;IAC3C,wBAAwB;IACxB,qCAAqC;IACrC,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;IACvC,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yCAAyC;IACzC,4CAA4C;IAC5C,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB","sourcesContent":["div.timeline-slider-container {\n    position: relative;\n    margin-top: 0.125em;\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--border-color);\n}\n\ndiv.timeline-slider {\n    touch-action: none;\n    flex: 1 1 auto;\n    background-color: white;\n    height: 35px;\n    min-height: 0px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: relative;\n    user-select: none;\n}\n\ndiv.timeline-slider-cursor {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    background-color: black;\n    z-index: 3;\n}\n\ndiv.timeline-slider-cursor-label {\n    position: absolute;\n    font-size: 70%;\n    bottom: 0;\n    text-align: center;\n    background-color: var(--container-bg-color);\n    color: var(--text-color);\n    border: 1px solid var(--border-color);\n    z-index: 4;\n    transform: translateX(-50%);\n    padding: 0 0.25em;\n}\n\ndiv.timeline-slider-cursor-label input {\n    border: none!important;\n    background-color: transparent!important;\n    padding: 0.125em!important;\n    height: initial!important;\n}\n\ndiv.timeline-slider-cursor-label input::-webkit-clear-button {\n    display: none;\n}\n\ndiv.timeline-slider-layertitle {\n    font-size: 75%;\n    padding: 0.25em;\n    border-top: 1px solid var(--border-color);\n    border-bottom: 1px solid var(--border-color);\n    background-color: white;\n    color: black;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    z-index: 4;\n    white-space: nowrap;\n    overflow-x: auto;\n}\n\ndiv.timeline-slider-layertitle > span:first-child {\n    font-weight: bold;\n    margin-right: 1em;\n}\n\ndiv.timeline-slider-layertitle > select {\n    margin-right: 1em;\n}\n\ndiv.timeline-slider-gradient {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    bottom: 0;\n    min-height: 100%;\n}\n\ndiv.timeline-slider-feature {\n    font-size: 75%;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    height: 24px;\n    padding: 0.25em;\n    border-radius: 4px;\n    background-color: var(--border-color);\n    border: 1px solid transparent;\n    z-index: 2;\n}\n\ndiv.timeline-slider-feature > span {\n    flex: 1 1 auto;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-align: center;\n}\n\ndiv.timeline-slider-feature:hover {\n    border: 1px solid var(--color-active);\n}\n\ndiv.timeline-slider-loading {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200, 0.9);\n    color: black;\n    z-index: 10;\n}\n\ndiv.timeline-slider-loading > div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
